import './style.css'

export default class RegisterInterest {
    static selector = '.register-interest'

    constructor(block) {
        this.block = block;
        this.registerInterestBtn = this.block.querySelector('.register-interest__btn');

        this.registerInterestBtn.addEventListener('click', () => {
            window.App.modals.registerInterestModal.open();
        })
    }

    onScroll() {
        if (window.scrollY > 300) {
            this.registerInterestBtn.classList.add('is-small');
        } else {
            this.registerInterestBtn.classList.remove('is-small');
        }
    }
}
